import type { ElementRef, SVGProps } from 'react';
import { forwardRef } from 'react';

export const FullModalAsideBottomOval = forwardRef<ElementRef<'svg'>, SVGProps<SVGSVGElement>>(
  (props: SVGProps<SVGSVGElement>, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="185"
        viewBox="0 0 157 185"
        width="157"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          clipRule="evenodd"
          d="M157 3.56394V184.459H13.7112C4.94272 167.205 0 147.68 0 127C0 56.8598 56.8598 0 127 0C137.335 0 147.381 1.23445 157 3.56394Z"
          fill="white"
          fillRule="evenodd"
          opacity="0.1"
        />
      </svg>
    );
  }
);

FullModalAsideBottomOval.displayName = 'FullModalAsideBottomOval';
